/* eslint-disable */
import axios from 'axios';
import { SET_CURRENT_USER, LOGIN, LOGOUT, VALIDATE_USER, VERIFY_2FA, SET_CURRENT_USER_EMAIL } from '../actions-mutations-type';
import JwtService from "@/services/jwt.service";
import { AuthService } from "@/services/ApiService";
import { getState, setState, removeState } from "@/utils/localStore";


const setDefaultAuthHeaders = function (state) {
    axios.defaults.headers.common.Authorization = state.currentUser ? state.currentUser.token : '';
};

const state = {
    currentUser: getState('auth.currentUser'),
    token: getState('auth.currentUser') || '',
    status: '',
    currentUserEmail: ''
};
const getters = {
    isAuthenticated: state => state.currentUser !== null && typeof state.currentUser.token !== "undefined",
    isAdmin: state => !!state.currentUser && state.currentUser.isAdmin,    
    authStatus: state => state.status,
    loggedIn(state) {
        var time = new Date().getTime();
        if (state.currentUser && time < state.currentUser.timestamp) {
            return !!state.currentUser;
        } else {
            JwtService.removeToken();
            setState('auth.currentUser', {});
            return false;
        }
    },
    adminLoggedIn(state) {
        var time = new Date().getTime();
        if (state.currentUser && time < state.currentUser.timestamp) {
            return !!state.currentUser && state.currentUser.isAdmin;
        } else {
            JwtService.removeToken();
            setState('auth.currentUser', {});
            return false;
        }
    },
    currentUser(state) {
        return state.currentUser;
    },
    currentUserEmail(state) {
        return state.currentUserEmail;
    }
};

const mutations = {
    [SET_CURRENT_USER](state, data) {
        state.currentUser = data;
        setState('auth.currentUser', data);
        //setDefaultAuthHeaders(state);
    },
    [SET_CURRENT_USER_EMAIL](state, data) {
        state.currentUserEmail = data;
        setState('auth.currentUserEmail', data);
    },
};

const actions = {
    initStore({ state, dispatch }) {
        //setDefaultAuthHeaders(state);
        //dispatch(VALIDATE_USER);
    },

    // Logs in the current user.
    async [LOGIN]({ commit, dispatch, getters }, { email, password } = {}) {
        //if (getters.loggedIn) return dispatch(VALIDATE_USER);
        var response = await AuthService.login({ email, password });
        if (response !== null && response.successful == true) {
            var userData = response;
            const timestamp = new Date(new Date().getTime() + 20 * 60 * 1000);
            const user = {
                id: userData.id,
                name: userData.firstname,
                email: userData.email,
                token: userData.token,
                timestamp: timestamp.getTime(),
                isAdmin: userData.isAdmin
            };

            JwtService.saveToken(userData.token);
            commit(SET_CURRENT_USER, user);

            return user;
        }

        commit(SET_CURRENT_USER_EMAIL, email);

        return response;
    },
    async [VERIFY_2FA]({ commit, dispatch, getters }, { provider, code, email } = {}) {
        var response = await AuthService.verify2Fa({ provider, code, email });
        if (response !== null && response.successful == true) {
            var userData = response;
            const timestamp = new Date(new Date().getTime() + 20 * 60 * 1000);
            const user = {
                id: userData.id,
                name: userData.firstname,
                email: userData.email,
                token: userData.token,
                timestamp: timestamp.getTime(),
                isAdmin: userData.isAdmin
            };

            JwtService.saveToken(userData.token);
            commit(SET_CURRENT_USER, user);

            return user;
        }

        return response;
    },
    // Logs out the current user.
    [LOGOUT]({ commit }) {
        commit(SET_CURRENT_USER, null);
        JwtService.removeToken();
    },

    [VALIDATE_USER]({ commit, state }) {
        if (!state.currentUser) return Promise.resolve(null);
        const user = {
            name: "Labi",
            email: "labi.egbeyemi@towergate.co.uk",
            token: "uJkt0aa2djHRR1qS8ErYVSEVufiBpq8f"
        };
        commit(SET_CURRENT_USER, {});
        return user;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
